import { gql } from '@apollo/client'

const CONTACT_QUERY = gql`
  query CONTACT_QUERY {
    offices {
      nodes {
        title
        acfOffices {
          contactDetails
          address
          contacts {
            title
            contactInfo {
              link {
                target
                title
                url
              }
              text
            }
            link {
              target
              title
              url
            }
          }
          facebookHandle
          instagramHandle
          latitude
          longitude
          mapLink
          twitterHandle
          tiktokHandle
        }
      }
    }
    pageBy(uri: "Contact") {
      title
      seo {
        title
        metaDesc
        removeBlogTitle
      }
    }
  }
`

export default CONTACT_QUERY
